import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import {
  Column,
  DataGrid,
  Editing,
  Export,
  HeaderFilter,
  Item,
  LoadPanel,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  Toolbar
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import notify from 'devextreme/ui/notify';

import { getApiToken } from '../../utils/authUtils';
import { EditCellTimeComponent, TimeBoxBold } from '../../components/utils/time-box/TimeBox';
import './squad_times.scss';
import { GENDERS, exportFormats } from '../../shared/constants';
import { checkPermission } from '../../permissions';




export const SquadTimes = () => {
  const { instance, accounts } = useMsal();
  const { squadId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const gridRef = useRef(null);

  const [dataSource, setDataSource] = useState();
  const [swimstyles, setSwimstyles] = useState();

  const addRow = useCallback(() => {
    gridRef.current?.instance().addRow();
  }, []);

  const squadName = location.state?.squadName;

  useEffect(() => {
    getApiToken(instance, accounts).then((token) => {
      const baseUrl = `${process.env.REACT_APP_serverEndpoint}/Squad`;
      setDataSource({
        store: createStore({
          key: 'squadtimeId',
          loadUrl: `${baseUrl}/SquadTimes`,
          insertUrl: `${baseUrl}/InsertSquadTime`,
          updateUrl: `${baseUrl}/UpdateSquadTime`,
          deleteUrl: `${baseUrl}/DeleteSquadTime`,
          onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
              Authorization: `Bearer ${token}`
            };

            if (ajaxOptions.data && ajaxOptions.data.values) {
              const values = JSON.parse(ajaxOptions.data.values);

              if (method === 'insert') {
                delete values.squadtimeId;
                values.squadId = squadId;
              }

              ajaxOptions.data.values = JSON.stringify(values);
            }
          }
        }),
        filter: ['squadId', '=', squadId]
      });

      const swimstylesDs = createStore({
        key: 'swimstyleId',
        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Swimstyle/Swimstyles`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`
          };
        }
      });

      swimstylesDs.load().done((data) => {
        setSwimstyles(data);
      });
    });
  }, [accounts, instance, squadId]);

  const refresh = useCallback(() => {
    gridRef.current?.instance().refresh();
  }, []);

  const notifyAction = useCallback((message) => {
    notify(
      {
        message,
        position: { at: 'bottom center', my: 'bottom center' }
      },
      'success',
      2000
    );
  }, []);

  return (
    <div className='view squad-times'>
      <div className='view-wrapper view-wrapper-squad-times list-page'>
        <DataGrid
          className='grid theme-dependent'
          noDataText=''

          height='100%'
          dataSource={dataSource}
          ref={gridRef}
          remoteOperations
          allowColumnReordering
          showBorders

          onDataErrorOccurred={() => notify({ message: 'Kaderzeiten konnten nicht geladen werden', position: { at: 'bottom center', my: 'bottom center' } }, 'error', 2500)}
          onRowInserted={() => { notifyAction('Kaderzeit gespeichert'); refresh(); }}
          onRowUpdated={() => { notifyAction('Kaderzeit aktualisiert'); refresh(); }}
          onRowRemoved={() => { notifyAction('Kaderzeit geloescht'); refresh(); }}
        >
          <LoadPanel showPane={false} />
          <SearchPanel visible placeholder='Kaderzeit suchen' />
          <Export enabled allowExportSelectedData formats={exportFormats} />
          <Selection mode='multiple' showCheckBoxesMode='always' />
          <HeaderFilter visible />
          <Sorting mode='multiple' />
          <Scrolling mode='virtual' />
          <Editing
            mode='row'
            allowAdding={checkPermission('squad.edit')}
            allowUpdating={checkPermission('squad.edit')}
            allowDeleting={checkPermission('squad.edit')}
            useIcons
          />
          <Toolbar>
            <Item location='before'>
              <Button
                icon='chevronleft'
                stylingMode='text'
                onClick={() => navigate(-1)}
              />
            </Item>
            <Item location='before'>
              <div className='grid-header'>
                {squadName ? `Kaderzeiten - ${squadName}` : 'Kaderzeiten'}
              </div>
            </Item>
            <Item
              location='after'
              locateInMenu='auto'
            >
              <Button
                icon='plus'
                text='Neue Kaderzeit'
                type='default'
                stylingMode='contained'
                onClick={addRow}
                disabled={!checkPermission('squad.edit')}
              />
            </Item>
            <Item
              location='after'
              locateInMenu='auto'
              showText='inMenu'
              widget='dxButton'
            >
              <Button icon='refresh' text='Refresh' stylingMode='text' onClick={refresh} />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>

            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>

          <Column dataField='swimstyleId' caption='Schwimmstil' hidingPriority={3} lookup={{ dataSource: swimstyles, valueExpr: 'swimstyleId', displayExpr: 'name' }} />
          <Column dataField='gender' caption='Geschlecht' width={120} hidingPriority={2} lookup={{ dataSource: GENDERS, valueExpr: 'id', displayExpr: 'text' }} />
          <Column dataField='birthdayStart' caption='Geburtstag von' dataType='date' format='dd.MM.yyyy' hidingPriority={1} />
          <Column dataField='birthdayEnd' caption='Geburtstag bis' dataType='date' format='dd.MM.yyyy' hidingPriority={0} />
                <Column
                    dataField='swimtime'
                    caption='Zeit'
                    dataType='number'
                    width={80}
                    cellRender={TimeBoxBold}
                    editCellComponent={EditCellTimeComponent}
                    hidingPriority={6}
                />
        </DataGrid>
      </div>
    </div>
  );
};
